export default __webpack_public_path__ + "e0621f00fd7e05eebb653199adeb6597.png";